module.exports = __webpack_public_path__ + "static/media/picture-(81).a1443dc9.JPG";